import Convector from './convector.svg';
import FloorHeating from './floor-heating.svg';
import GreenHouse from './greenhouse.svg';
import HWB from './hwb.svg';
import DHW from './hws.svg';
import Pool from './pool.svg';
import Radiator from './radiator.svg';
import BoilerGas from './boiler-gas.svg';
import BoilerEl from './boiler-electro.svg';
import AirConditioner from './airconditioner.svg';
import Buffer from './buffer.svg';
import HeatExChanger from './heatexchanger.svg';
import HeatPump from './heatpump.svg';
import Ventilation from './ventilation.svg';
import Aquarium from './aquarium.svg';
import Coffee from './coffee.svg';
import Conditioner from './conditioner.svg';
import Floor from './floor.svg';
import Fridge from './fridge.svg';
import Garland from './garland.svg';
import Heater from './heater.svg';
import Humidifier from './humidifier.svg';
import Iron from './iron.svg';
import Kettle from './kettle.svg';
import Lamp from './lamp.svg';
import Router from './router.svg';
import Tv from './tv.svg';
import Washer from './washer.svg';
import Gates from './gates.svg';
import Rollershutters from './rollershutters.svg';
export const heating_circuits_custom_icons = [
    {
        id: 0,
        render: null,
        title: '',
        paid: false,
    },
    {
        id: 1,
        render: Convector,
        title: 'Конвектор',
        paid: false,
        similar: [1, 354, 355, 356, 357, 358],
    },
    {
        id: 2,
        render: FloorHeating,
        title: 'Теплый пол',
        paid: false,
        similar: [2, 308, 324],
    },
    {
        id: 308,
        render: Floor,
        title: 'Теплый пол',
        paid: false,
    },
    {
        id: 3,
        render: GreenHouse,
        title: 'Теплица',
        paid: false,
        similar: [3, 167, 168, 169, 170, 171, 172],
    },
    {
        id: 4,
        render: HWB,
        title: 'БКН',
        paid: false,
    },
    {
        id: 5,
        render: DHW,
        title: 'ГВС',
        paid: false,
    },
    {
        id: 6,
        render: Pool,
        title: 'Бассейн',
        paid: false,
        similar: [6, 101, 102, 103, 104, 105, 106],
    },
    {
        id: 7,
        render: Radiator,
        title: 'Радиатор',
        paid: false,
        similar: [7, 364, 365, 366, 367, 368],
    },
    {
        id: 8,
        render: BoilerGas,
        title: 'Газовый котёл',
        paid: false,
        similar: [8, 389, 390, 391, 392, 393],
    },
    {
        id: 9,
        render: BoilerEl,
        title: 'Электрический котёл',
        paid: false,
        similar: [9, 394, 395, 396, 397, 398],
    },
    {
        id: 10,
        render: AirConditioner,
        title: 'Кондиционер',
        paid: false,
        similar: [10, 307, 349, 350, 351, 352, 353, 323],
    },
    {
        id: 307,
        render: Conditioner,
        title: 'Кондиционер',
        paid: false,
    },
    {
        id: 11,
        render: Buffer,
        title: 'Буферная ёмкость',
        paid: false,
    },
    {
        id: 12,
        render: HeatExChanger,
        title: 'Теплообменник',
        paid: false,
    },
    {
        id: 13,
        render: HeatPump,
        title: 'Тепловой насос',
        paid: false,
    },
    {
        id: 14,
        render: Ventilation,
        title: 'Вентиляция',
        paid: false,
    },
    {
        id: 305,
        render: Aquarium,
        title: 'Аквариум',
        paid: false,
        similar: [305, 321],
    },
    {
        id: 306,
        render: Coffee,
        title: 'Кофеварка',
        paid: false,
        similar: [306, 322],
    },
    {
        id: 309,
        render: Fridge,
        title: 'Холодильник',
        paid: false,
        similar: [309, 325],
    },
    {
        id: 310,
        render: Garland,
        title: 'Гирлянда',
        paid: false,
        similar: [310, 326],
    },
    {
        id: 311,
        render: Heater,
        title: 'Обогреватель',
        paid: false,
        similar: [311, 359, 360, 361, 362, 363, 327],
    },
    {
        id: 312,
        render: Humidifier,
        title: 'Увлажнитель воздуха',
        paid: false,
        similar: [312, 328],
    },
    {
        id: 313,
        render: Iron,
        title: 'Утюг',
        paid: false,
        similar: [313, 329],
    },
    {
        id: 314,
        render: Kettle,
        title: 'Чайник',
        paid: false,
        similar: [314, 330],
    },
    {
        id: 315,
        render: Lamp,
        title: 'Светильник',
        paid: false,
        similar: [315, 369, 370, 371, 372, 373, 331],
    },
    {
        id: 316,
        render: Router,
        title: 'Роутер',
        paid: false,
        similar: [316, 332],
    },
    {
        id: 317,
        render: Tv,
        title: 'Телевизор',
        paid: false,
        similar: [317, 333],
    },
    {
        id: 318,
        render: Washer,
        title: 'Стиральная машинка',
        paid: false,
        similar: [318, 335],
    },
    {
        id: 319,
        render: Gates,
        title: 'Ворота',
        paid: false,
        similar: [319, 336],
    },
    {
        id: 320,
        render: Rollershutters,
        title: 'Рольставни',
        paid: false,
        similar: [320, 337],
    },
];
